import axios from "axios";
import API_BASE_URL from "../config";

const addEventService = async (token, name) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/crear-evento/`, { name }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error('Error in Adding Event');
    }
}

export default addEventService;